// extracted by mini-css-extract-plugin
export default {"-large":"Fp2F7ZU4zn0NWJoVJVWd","paletteContainer":"ec0r05mNOcPKD7dty0DN","wide":"ABFuU0JC7RzS06bUCtK6","viewSwitchButton":"yw0zSl3B9bQnngdZdOa8"};